(() => {
  if (window.garrnishMenuImageLoading) return;
  window.garrnishMenuImageLoading = true;
  const loadOpenMenu = () => {
    if (!document.body.classList.contains('menu-open')) return;
    document.querySelectorAll('img[data-menu-src]').forEach((image) => {
      if (image.dataset.menuSrcset) image.srcset = image.dataset.menuSrcset;
      image.src = image.dataset.menuSrc;
      delete image.dataset.menuSrc;
      delete image.dataset.menuSrcset;
    });
  };
  new MutationObserver(loadOpenMenu).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
  document.addEventListener('shopify:section:load', loadOpenMenu);
  loadOpenMenu();
})();
